import { render } from "./about-testimonials.vue?vue&type=template&id=5b2ce731"
import script from "./about-testimonials.vue?vue&type=script&lang=js"
export * from "./about-testimonials.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__